import { useAbility } from '@casl/vue'
import { usePermissions } from '@/composables/usePermissions'

/**
 * Returns ability result if ACL is configured or else just return true
 * We should allow passing string | undefined to can because for admin ability we omit defining action & subject
 *
 * Useful if you don't know if ACL is configured or not
 * Used in @core files to handle absence of ACL without errors
 *
 * @param {string} action CASL Actions // https://casl.js.org/v4/en/guide/intro#basics
 * @param {string} subject CASL Subject // https://casl.js.org/v4/en/guide/intro#basics
 */
export const can = (action, subject) => {
  const vm = getCurrentInstance()
  if (!vm)
    return false
  const localCan = vm.proxy && '$can' in vm.proxy

  return localCan ? vm.proxy?.$can(action, subject) : true
}

/**
 * Check if user can view item based on it's ability
 * Based on item's action and subject & Hide group if all of it's children are hidden
 * @param {object} item navigation object item
 */
export const canViewNavMenuGroup = item => {
  // Import VIMS permission function
  const { can: vimsCanFunction, isAdmin } = usePermissions()

  const canViewItem = navItem => {
    if (navItem.adminOnly && !isAdmin())
      return false

    if (navItem.permission)
      return vimsCanFunction(navItem.permission)

    return can(navItem.action, navItem.subject)
  }

  const hasAnyVisibleChild = item.children.some(child => canViewItem(child))

  if (item.adminOnly && !isAdmin())
    return false

  // Check parent permission using VIMS format first, then CASL format
  if (item.permission) {
    // VIMS format: check parent permission AND has visible children
    return vimsCanFunction(item.permission) && hasAnyVisibleChild
  }

  // CASL format (legacy): If subject and action is defined in item => Return based on children visibility
  if (!(item.action && item.subject))
    return hasAnyVisibleChild

  return can(item.action, item.subject) && hasAnyVisibleChild
}
export const canNavigate = to => {
  const ability = useAbility()


  return to.matched.some(route => {
    return ability.can(route.meta.action, route.meta.subject)
  })
}
